import React, { useEffect, useState } from 'react';
import CtrChart from './CtrChart';
import { Button, ButtonGroup, Nav, Offcanvas, Spinner } from 'react-bootstrap';
import { MdOutlineOpenInNew } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { colorByIndex } from '@/helpers/utils';
import { FaDesktop, FaMobileScreenButton } from 'react-icons/fa6';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DrawerWrapper from '@/app/common/components/DrawerWrapper';
import { hideDrawer } from '@/app/common/reducers/drawer';

const CtrDrawer = () => {
  const dispatch = useDispatch();
  const { key, payload } = useSelector(state => state.drawer);
  const { desktop, mobile, keyword } = payload ?? '';
  const [viewChartMode, setViewChartMode] = useState('desktop');

  return (
    <DrawerWrapper
      show={key === 'ctr'}
      title={
        <div className="d-flex flex-wrap gap-3 align-items-center">
          <h6 className="m-0">
            نمودار CRT کلمه &nbsp;
            <strong>{keyword ? decodeURIComponent(keyword) : ''}</strong>
            {/* <HelpTooltip html={'23'} /> */}
          </h6>
          <Nav
            variant="tabs"
            style={{
              borderLeft: '0px solid var(--falcon-border-color)'
              // marginTop: '-13px'
            }}
          >
            <ButtonGroup>
              <Nav.Item
                as={Button}
                active={viewChartMode === 'desktop'}
                onClick={() => setViewChartMode('desktop')}
                variant="outline-primary"
                size="sm"
              >
                <FaDesktop />
              </Nav.Item>
              <Nav.Item
                as={Button}
                active={viewChartMode === 'mobile'}
                onClick={() => setViewChartMode('mobile')}
                variant="outline-primary"
                size="sm"
              >
                <FaMobileScreenButton />
              </Nav.Item>
            </ButtonGroup>
          </Nav>
        </div>
      }
    >
      <div className="m-lg-5">
        {(mobile || desktop) && (
          <CtrChart
            setViewChartMode={setViewChartMode}
            viewChartMode={viewChartMode}
            data={(viewChartMode === 'desktop' ? desktop : mobile)
              .map((num, i) => ({
                value: num,
                itemStyle: {
                  color: colorByIndex(i),
                  borderRadius: [0, 3, 3, 0]
                }
              }))
              .reverse()}
          />
        )}
      </div>
    </DrawerWrapper>
  );
};

export default CtrDrawer;
